<template>
  <div class="paypal_area">
    <div id="paypal-button-container">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PayPalButton',
  components: {
  },
  data: () => ({
    payMethod: '',
  }),
  props: {
    amount: {
      type: String || Number || Object || Array || Boolean || Function || Symbol,
    },
    pointPriceId: {
      type: String || Number,
      default: null,
    },
    isMarket: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      currentUserDetail: 'user/currentUserDetail',
    }),
  },
  async mounted() {
    await new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.VUE_APP_PAYPAL_CLIENT_ID}&disable-funding=card&locale=en_US&currency=JPY`;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });

    // PayPalのSDKが読み込まれた後に実行する処理をここに記述
    this.setupPayPalButtons();
  },
  methods: {
    setupPayPalButtons() {
      if (this.isMarket) {
        this.setupBackendDrivenMarketButtons();
        return;
      }
      this.setupBackendDrivenButtons();
    },
    // ポイント購入向け: サーバー経由で Order 作成・Capture を行う（金額改ざん防止）
    setupBackendDrivenButtons() {
      window.paypal.Buttons({
        commit: false,
        onClick: async (data, actions) => {
          // 0円購入は PayPal を経由せずサーバーで完結させる
          if (Number(this.amount) === 0) {
            const created = await this.$store.dispatch('user/paypalCreateOrder', {
              postParams: { point_price_id: this.pointPriceId },
            });
            if (!created || (created.errors && Object.keys(created.errors).length)) {
              alert('Payment failed\nPlease check your PayPal status');
              return actions.reject();
            }
            await this.$store.dispatch('user/paypalCaptureOrder', { postParams: {} });
            return actions.reject();
          }
          return actions.resolve();
        },
        createOrder: async () => {
          const created = await this.$store.dispatch('user/paypalCreateOrder', {
            postParams: { point_price_id: this.pointPriceId },
          });
          if (!created || !created.orderId) {
            throw new Error('Failed to create PayPal order');
          }
          return created.orderId;
        },
        onApprove: async (data) => {
          await this.$store.dispatch('user/paypalCaptureOrder', {
            postParams: { paypalOrderId: data.orderID },
          });
        },
        onError: () => {
          alert('An error has occurred');
        },
      }).render('#paypal-button-container');
    },
    // マーケット購入向け: サーバー経由で Order 作成・Capture を行う（金額改ざん防止）
    setupBackendDrivenMarketButtons() {
      window.paypal.Buttons({
        commit: false,
        onClick: async (data, actions) => {
          // 0円購入は PayPal を経由せずサーバーで完結させる
          if (Number(this.amount) === 0) {
            const created = await this.$store.dispatch('market/marketPaypalCreateOrder', {
              postParams: {},
            });
            if (!created || (created.errors && Object.keys(created.errors).length)) {
              alert('Payment failed\nPlease check your PayPal status');
              return actions.reject();
            }
            await this.$store.dispatch('market/marketPaypalCaptureOrder', { postParams: {} });
            return actions.reject();
          }
          return actions.resolve();
        },
        createOrder: async () => {
          const created = await this.$store.dispatch('market/marketPaypalCreateOrder', {
            postParams: {},
          });
          if (!created || !created.orderId) {
            throw new Error('Failed to create PayPal order');
          }
          return created.orderId;
        },
        onApprove: async (data) => {
          await this.$store.dispatch('market/marketPaypalCaptureOrder', {
            postParams: { paypalOrderId: data.orderID },
          });
        },
        onError: () => {
          alert('An error has occurred');
        },
      }).render('#paypal-button-container');
    },
  },
};
</script>

<style lang="scss" scoped>
#paypal-button-container {
  margin: 10px auto 0;
}
</style>
